
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable persistent 
      :overlay="false" 
      :max-width="loading ? '33%' : '80%'" 
      transition="dialog-transition" 
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando produto</span>
        </v-card-title>
        <card-loading-transparent v-if="loading || saving" :loadingText="loading ? 'Carregando' : 'Salvando'"></card-loading-transparent>
        <v-card-text v-if="!loading">

          <v-form v-if="!saving && !loading" ref="form">
            <v-text-field v-model="supplier_product.name" label="Nome do produto"></v-text-field>
            <!-- @input="checkName(supplier_product.name, all_products)" -->
            <v-select 
              :rules="required" 
              :items="all_segments" 
              v-model="supplier_product.segment_id" 
              item-text="name"
              item-value="id" 
              label="Segmento" 
              prepend-icon="mdi-information"
              :menu-props="{ top: false, offsetY: true }"
            ></v-select>
          </v-form>


          <!-- <v-col cols='10' md='7' class="mb-3">
            <v-btn :disabled="!user_allowed" 
              small 
              class="white--text font-weight-bold" 
              rounded block color="grey" 
              @click="edit_commission_products = true, editing_comission = true"
            ><v-icon small left>mdi-pencil</v-icon> comissao por vendedores</v-btn>
          </v-col> -->

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog()"></f-btn>
          <f-btn save @click="updateProduct()" :disabled="!user_allowed || saving"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-list-comission 
      v-if="edit_commission_products" 
      is_product 
      :editing="editing_comission" 
      @close="edit_commission_products = false; editing_comission = false" 
      :main_data="Object.keys(supplier_product).length > 1 ? supplier_product : { comissions_attributes: [], ...oneProduct.data.attributes }"
    ></dialog-list-comission>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations";
import Api from '@/api/index';

export default {
  name: 'EditProduct',
  mixins: [ validations ],
  components: {
    DialogListComission: () => import('./DialogListComission.vue'),
  },
  data() {
    return {
      dialog: true,
      supplier_product: null,
      loading: true,
      all_segments: [],
      saving: false,
      edit_commission_products: false,
      had_updated: false,
      params_aux: {}
    }
  },
  methods: {
    async getData(){
      this.loading = true
      let data = await this.getProduct()
      this.supplier_product = data
      this.getSegments()

      this.loading = false
    },
    async getProduct() {
      let data = {}

      await Api.Supplier.show({id: this.productId, type: 'products'}).then(r=>{

      let { name, brand_ids, status_id, comission_ids, segment_id } = r.data.data.attributes
      data = {
        id: r.data.data.attributes.id,
        name, brand_ids, status_id, comission_ids, segment_id,
        comissions_attributes: [],
      }
      this.edit_product = true
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        
      })
      return data
    },
    getSegments() {
      Api.Supplier.indexSegment().then(r => r.data).then(d => {
        this.all_segments = [...d]
      })
    },

    updateProduct(){
      if(this.$refs.form.validate()){
        this.swallConfirmation({
          title: 'Deseja atualizar informações do produto?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
    
            let product = {
              id: this.supplier_product.id,
              name: this.supplier_product.name,
              segment_id: this.supplier_product.segment_id,
              status_id: 1
            }
            Api.Supplier.updateOnlyProduct(product).then((r) =>{
              this.had_updated = true
              this.params_aux = {
                product_updated_id: r.data.data.attributes.id,
                name: r.data.data.attributes.name,
                segment_id: r.data.data.attributes.segment_id,
                segment_name: r.data.data.attributes.segment_name
              }
              this.addNotification({type: 'success',  msg: `Atualizado com sucesso.`})
            }).catch((err) =>{
              this.addNotification({type: 'error',  msg: `Erro: ${err}`})
            }).finally(() =>{
              this.saving = false
            })

          }
        })
      }
    },
    closeDialog(){
      if (this.$route.name === 'EditBrandProduct') {
        this.$router.push({name: 'EditBrand', params: {id: this.$route.params.id, ...this.params_aux}})
      } else {
        this.$router.push({name: 'ProductsList', params: {...this.params_aux}})
      }
    },

  },
  computed: {
    productId() {
      return this.$route.name === 'EditBrandProduct'
        ? this.$route.params.productId
        : this.$route.params.id
    },
    user_allowed() {
      return ['Manager', 'Director', 'SalesExecutive'].includes(this.profile?.included[0]?.attributes?.role?.data[0]?.attributes?.name)
    },
    ...mapState({
      profile: state => state.User.oneUser,
    })
  },
  watch: {
    edit_commission_products(nv, ov) {
      if (nv) {
        this.supplierInfo.comissions_attributes = []
      } else if (nv == false) {
        this.supplierInfo.comissions_attributes = []
      }
    },
  },
  mounted () {
    this.getData();
  },
}
</script>

<style scoped>

</style>